export type PositionStaffingDragPayload =
  | { readonly kind: 'person'; readonly personId: string }
  | { readonly kind: 'assignment'; readonly assignmentId: string; readonly personId: string; readonly sourcePositionId: string };

export type PositionStaffingDropResolution =
  | { readonly outcome: 'assign'; readonly personId: string; readonly targetPositionId: string }
  | { readonly outcome: 'move'; readonly assignmentId: string; readonly targetPositionId: string }
  | { readonly outcome: 'unassign'; readonly assignmentId: string }
  | { readonly outcome: 'noop'; readonly reason: 'same_position' }
  | { readonly outcome: 'rejected'; readonly reason: 'outside_body' | 'incomplete' | 'read_only' | 'target_primary_occupied' };

/** Pure decision table shared by native and Konva pointer-drop paths. */
export function resolvePositionStaffingDrop(input: {
  readonly payload: PositionStaffingDragPayload;
  readonly targetPositionId: string | null;
  readonly droppedOnBody: boolean;
  readonly canWrite: boolean;
  readonly occupancyComplete: boolean;
  readonly targetHasPrimaryOccupant: boolean;
  readonly unassignZone?: boolean;
}): PositionStaffingDropResolution {
  if (input.unassignZone && input.payload.kind === 'assignment') {
    if (!input.canWrite) return { outcome: 'rejected', reason: 'read_only' };
    if (!input.occupancyComplete) return { outcome: 'rejected', reason: 'incomplete' };
    return { outcome: 'unassign', assignmentId: input.payload.assignmentId };
  }
  if (!input.droppedOnBody || !input.targetPositionId) {
    return { outcome: 'rejected', reason: 'outside_body' };
  }
  if (!input.canWrite) return { outcome: 'rejected', reason: 'read_only' };
  if (!input.occupancyComplete) return { outcome: 'rejected', reason: 'incomplete' };
  if (input.payload.kind === 'assignment' && input.payload.sourcePositionId === input.targetPositionId) {
    return { outcome: 'noop', reason: 'same_position' };
  }
  if (input.targetHasPrimaryOccupant) {
    return { outcome: 'rejected', reason: 'target_primary_occupied' };
  }
  return input.payload.kind === 'person'
    ? { outcome: 'assign', personId: input.payload.personId, targetPositionId: input.targetPositionId }
    : { outcome: 'move', assignmentId: input.payload.assignmentId, targetPositionId: input.targetPositionId };
}
